import React, { useEffect, useState, useContext } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { tableAPI, authAPI } from '../api/api';
import { AuthContext } from '../context/AuthContext';
import './Dashboard.css';

function Dashboard() {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const [tables, setTables] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    fetchTables();
    // Get admin status from user context
    if (user) {
      const userRole = user.Role || user.role || '';
      setIsAdmin(userRole.toLowerCase() === 'admin');
    }
  }, [user]);

  const fetchTables = async () => {
    try {
      const response = await tableAPI.getAllTables();
      if (response.data.success) {
        setTables(response.data.tables);
      }
    } catch (err) {
      setError('Failed to load tables');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <Container className="mt-5"><p>Loading...</p></Container>;
  }

  if (error) {
    return <Container className="mt-5"><p className="text-danger">{error}</p></Container>;
  }

  return (
    <Container fluid className="dashboard">
      <div className="dashboard-welcome">
        <p>Welcome to AAIMS! Use the top navigation to navigate to tables and manage your data.</p>
      </div>

      <h1 className="mb-4">Dashboard</h1>
      
      {isAdmin && (
        <Row className="mb-4">
          <Col md={3}>
            <Card className="stat-card clickable-card" onClick={() => navigate('/tables')}>
              <Card.Body>
                <div className="stat-number">{tables.length}</div>
                <div className="stat-label">Available Tables</div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      )}
    </Container>
  );
}

export default Dashboard;
